import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ConstantsService {
    readonly appUrl: string = environment.APP_CDN;
    readonly confirmButtonCSS = 'mdc-button fids-tooltip mdc-button--raised mdc-button--sharp m-t-10';
    readonly cancelButtonCSS = 'mdc-button btn-margin-left m-l-1rem m-t-10';
    readonly applicationName = 'EY Release Management';
    readonly releaseTitle = 'Add and View Releases';
    readonly releaseDescription = 'Add a new release or view existing releases';
    readonly ReleaseStatusNew = 'Not started';
    readonly ReleaseStatusSuccess = 'Success';
    readonly ReleaseStatusFailed = 'Failed';
    readonly ReleaseStatusInProgress = 'In progress';
    readonly approved = 'APPROVED';
    readonly unApproved = 'UNAPPROVED';
    readonly revoked = 'REVOKED';
    readonly RollbackStatusNotStarted = 'Not Started';
    readonly RollbackStatusCompleted = 'Completed';
    readonly RollbackStatusFailed = 'Failed';
    readonly RollbackStatusInProgress = 'In Progress';
  readonly alreadyRegistered = 'AlreadyRegistered';

    readonly NoEnvironmentSelected = 'Looks like no environment has been selected.';
    readonly SelectEnvironment = 'Please select an environment first.';

    readonly sliderWidth = '30%';
    readonly sliderWidth35 = '35%';
    readonly sliderWidth38 = '38%';
    readonly sliderWidth50 = '50%';
    readonly sliderWidth42 = '42%';
    readonly sliderWidth40 = '40%';
    readonly sliderWidth70 = '70%';
    readonly sliderResetWidth = '0px';

    readonly RollbackMigrationStatusSuccess = 'Success';
    readonly RollbackMigrationStatusFailed = 'Failed';
  readonly success = 'Success';
    readonly invaliduser = 'InvalidUser';

  readonly fail = 'Fail';

  readonly NO_ENVIRONMENT_MAPPING_FOUND = 'Selected environment for rollback not found.';
  readonly NO_RELEASE_SERVICE_MAPPING_FOUND = 'Selected service for rollback not found.';
  readonly NO_RELEASE_FOUND = 'Selected release for rollback not found.';
  readonly ROLLBACK_JOB_ALREADY_IN_PROGRESS = 'Previous rollback job for selected service-environment is already in progress, please try after some time.';
  readonly SPECIFIED_ROLLBACK_VERSION_NOT_FOUND = 'Selected release version rollback details not found.';
  readonly ROLLBACK_FILE_NOT_FOUND = 'Selected release version rollback details not found.';
  readonly Missing_Url_Path = 'Missing URL path';
  readonly Missing_ClientKey_Or_ApiKey = 'Missing client key or api key';
  readonly InvalidToken = 'Invalid token';
  usersPerpage: number;
  readonly firstNamePattern = /^[^\[\]%@\{\}\^|#<>=~`\\]+$/;// NOSONAR
   readonly host = 'host';

  // NOSONAR: Static permission keys for application use
  readonly PERMISSION_KEYS = {
    'MANAGE.RELEASE': '1.0.0',
    'MANAGE.RELEASE.ADD': '1.1.0',
    'MANAGE.RELEASE.MODIFY': '1.2.0',
    'MANAGE.RELEASE.STATUS.VIEW': '1.3.0',
    'MANAGE.RELEASE.AUDIT.VIEW': '1.4.0',
    'MANAGE.BRANCH': '2.0.0',
    'MANAGE.BRANCH.ADD': '2.1.0',
    'MANAGE.BRANCH.STATUS.VIEW': '2.3.0',
    'MANAGE.MANIFEST': '3.0.0',
    'MANAGE.MANIFEST.TRIGGER': '3.1.0',
    'MANAGE.MANIFEST.STATUS.VIEW': '3.2.0',
    'MANAGE.RELEASE.DEPLOYMENT': '4.0.0',
    'MANAGE.RELEASE.DEPLOYMENT.PIPELINE.TRIGGER': '4.1.0',
    'MANAGE.RELEASE.DEPLOYMENT.STATUS.VIEW': '4.3.0',
    'MANAGE.RELEASE.DEPLOYMENT.HEALTH.STATUS': '4.4.0',
    'MANAGE.SYNC.DB.MIGRATION.ROLLBACK': '5.5.0',
    'MANAGE.RELEASE.ACTIONS':'2.0.0.0',//NOSONAR
    'MANAGE.SERVICES.ENVIRONMENTS':'6.0.0',
    'MANAGE.SERVICES.ENVIRONMENTS.ADD':'6.1.0',
    'MANAGE.SERVICES.ENVIRONMENTS.MODIFY':'6.2.0',
    'MANAGE.SERVICES.ENVIRONMENTS.VIEW':'6.3.0',
    'TRIGGER.ROLLBACK.DATABASE':'5.6.0',
    'MANAGE.ROLLBACK.STATUS.VIEW':'5.7.0',
    'MANAGE.USERS.ROLES':'7.1.0'
  }

}